<div class="row" *ngIf="pageHeaderVm as vm">
    <div class="col-md-12 pb-3">
        <div class="d-flex justify-content-start align-items-center flex-wrap">
            <div style="border-radius: 4px;"
                class="text-center view overlay gradient-card-header rtr-background-green-bold py-2 px-5 white-text">
                <h1 class="h1-responsive mb-0">{{vm.title}}</h1>
                <div *ngIf="vm.subTitle">
                    {{vm.subTitle}}
                </div>
            </div>

            <!-- actions -->
            <div class="pl-5 pt-2 pt-sm-0" *ngIf="!vm.formDisplayed">
                <a (click)="backClicked.emit(vm)">
                    <mdb-icon class="rtr-text-green-light" fas icon="arrow-left" size="2x" mdbTooltip="Go back"
                        placement="top"></mdb-icon>
                </a>
                <a *ngIf="vm.edit" class="pl-4" (click)="editClicked.emit(vm)">
                    <mdb-icon class="rtr-text-green-light" fas icon="edit" size="2x" mdbTooltip="Edit" placement="top">
                    </mdb-icon>
                </a>
                <a *ngIf="vm.delete" class="pl-4" (click)="deleteClicked.emit(vm)">
                    <mdb-icon class="rtr-text-green-light" fas icon="trash" size="2x" mdbTooltip="Delete" placement="top">
                    </mdb-icon>
                </a>
                <a *ngIf="vm.info" class="pl-4" (click)="infoClicked.emit(vm)">
                    <mdb-icon class="rtr-text-green-light" fas icon="info-circle" size="2x" mdbTooltip="Disclaimer" placement="top">
                    </mdb-icon>
                </a>
                <a *ngIf="vm.copy" class="pl-4" (click)="copyClicked.emit(vm)">
                    <mdb-icon class="rtr-text-green-light" fas icon="copy" size="2x" mdbTooltip="Make a copy" placement="top">
                    </mdb-icon>
                </a>
            </div>

            <!-- nav -->
            <div class="pl-5" *ngIf="!vm.formDisplayed && vm.navVm">
                <div *ngIf="vm.navVm as nvm">
                    <a href="javascript:void(0);" (click)="prevClicked.emit(vm)">
                        <mdb-icon
                            [ngClass]="{ 'rtr-text-green-light': nvm.prevEnabled, 'icon-disabled': !nvm.prevEnabled }"
                            fas icon="angle-double-left" size="2x" mdbTooltip="Previous" placement="top"></mdb-icon>
                    </a>
                    <a class="pl-2" href="javascript:void(0);" (click)="nextClicked.emit(vm)">
                        <mdb-icon
                            [ngClass]="{ 'rtr-text-green-light': nvm.nextEnabled, 'icon-disabled': !nvm.nextEnabled }"
                            fas icon="angle-double-right" size="2x" mdbTooltip="Next" placement="top"></mdb-icon>
                    </a>
                </div>
            </div>
        </div>

    </div>
</div>